import { apiClient } from '../client';
import { ApiResponse } from '../../../contract/types';
import { TenantQueryParams } from '../../../contract/dtos';
import { Create_Update_BranchPayload as Create_Update_TenantBranchPayload} from '../../../contract/dtos/request';


// Get tenant information with query parameters
export const getTenant = async (params?: TenantQueryParams): Promise<ApiResponse<any[]>> => {
  const response = await apiClient.get('/corporate/v1/tenant', {
    params: {
      ...params,
      
    },
  });
  const total = parseInt(response.headers['x-total-count'] || '0', 10);
  const totalPages = Math.ceil(total / (params?.size || total));

  return {
    data: response.data,
    total,
    totalPages,
  };
};


export const createTenantBranch = async (
  tenantId: number,
  componentId: number,
  data: Create_Update_TenantBranchPayload
): Promise<ApiResponse<any>> => {
  const response = await apiClient.put(`/corporate/v1/tenant/${tenantId}/branch?component_id=${componentId}`, data);
  
  return {
    data: response.data,
    total: 0,
  };
};